export default __webpack_public_path__ + "static/media/IconSettingActive.5d27d882.svg";